import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import Footer from "../../UI/Footer";
import Navbar from "../../UI/Navbar";
function AboutUsHeader() {
  return (
    <>
      <Box
        sx={{
          // width: "100%",
          // height: "100%",
          backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0) 70%, rgba(255, 255, 255, 0.908) 100%), url('/images/firstbackground.png')`,
          backgroundSize: "100% 80rem",
          backgroundPosition: "top",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Navbar></Navbar>
        <Stack
          direction={{ xs: "column", md: "column", lg: "column" }}
          spacing={6}
          sx={{ py: "16rem", px: "10rem", pb: "30rem" }}
        >
          {/* <Navbar /> */}
          <Typography
            variant="h1"
            sx={{ pl: "2.2rem", pr: "30rem", lineHeight: "8.4rem" }}
          >
            Meet our team of <strong>developers, designers</strong> and
            world-class <strong>problem solvers</strong>
          </Typography>
          <Typography
            variant="h4"
            margin="0rem"
            sx={{
              pl: "2.2rem",
              pr: "30rem",
              lineHeight: "3.4rem",
            }}
          >
            To be the company our costumers want us to be, It takes an{" "}
            <strong>eclectic group</strong> of passionate operators. Get to know
            the people <strong>leading the way</strong> at Coding Forge.
          </Typography>
          <Stack sx={{ pt: "8rem" }} direction="row" gap={6}>
            <Box
              sx={{ width: "30%", height: "35rem", backgroundColor: "#d9d9d9" }}
            ></Box>
            <Box
              sx={{ width: "30%", height: "35rem", backgroundColor: "#d9d9d9" }}
            ></Box>
            <Box
              sx={{ width: "30%", height: "35rem", backgroundColor: "#d9d9d9" }}
            ></Box>
          </Stack>
        </Stack>
      </Box>
      <Footer />
    </>
  );
}

export default AboutUsHeader;
